{
  "nav": {
    "tools": "Tools",
    "openMenu": "Open menu",
    "subscription": "Subscription",
    "configuration": "Configuration",
    "account": "Account",
    "administration": "Administration",
    "ourTools": "Our Tools",
    "pricing": "Pricing",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Flipping Tool",
    "dropshipTool": "Dropship Tool",
    "housingTool": "Housing Tool",
    "inventoryAnalysisTool": "Inventory Analysis Tool",
    "snipeAlerts": "Snipe Alerts",
    "realmStats": "Realm Stats",
    "tsmListGenerator": "TSM List Generator",
    "tsmProfileSetupGuide": "TSM Profile Setup Guide",
    "dashboard": "Dashboard",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Region & Realm Configuration",
    "personal": "Personal configuration",
    "discord": "Discord configuration"
  },
  "accountItems": {
    "settings": "Settings"
  },
  "adminItems": {
    "stats": "Stats",
    "userInfo": "User Info",
    "goldSubscription": "Gold subscription",
    "itemLookup": "Item Lookup",
    "snipeAudit": "Snipe Audit",
    "emailPreviews": "Email Previews"
  },
  "buttons": {
    "login": "Login",
    "logout": "Logout",
    "register": "Register",
    "registerNow": "Register Now",
    "signIn": "Sign in",
    "tryAgain": "Try Again",
    "goBack": "Go Back",
    "cancel": "Cancel",
    "deactivate": "Deactivate",
    "upgrade": "Upgrade",
    "upgradeToPremium": "Upgrade to Premium",
    "upgradeNow": "Upgrade Now",
    "unlockPremiumFeatures": "Unlock Premium Features",
    "getMoreResultsAndFilters": "Get more results and filters",
    "goToConfig": "Go to Config",
    "save": "Save",
    "close": "Close",
    "actions": "Actions",
    "copyToClipboard": "Copy to Clipboard",
    "saving": "Saving…"
  },
  "loading": {
    "pleaseWait": "Please Wait",
    "important": "Important",
    "defaultWarning": "Please do not reload the page during this process.",
    "progressComplete": "{{percent}}% complete",
    "loadingAriaLabel": "Loading",
    "loadingProgressAriaLabel": "Loading progress: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Something went wrong",
    "defaultMessage": "An error happened! Try waiting a few seconds and reloading the page",
    "fetchDataFailed": "Failed to fetch auction data"
  },
  "cancelDialog": {
    "title": "Cancel subscription",
    "confirmQuestion": "Are you sure you want to cancel your subscription?",
    "loseAccessNotice": "You will lose access to the tools and will no longer be charged future payments.",
    "warning": "Warning: Once you cancel your subscription you will lose access to the tools after your paid access ends and we will not refund for cancelled subscriptions."
  },
  "dialog": {
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "realmLimitPopup": {
    "title": "Realm Limit Exceeded",
    "description": "You have more selling realms selected than the basic subscription allows. Please change your config or upgrade to premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Upgrade to Premium",
    "upgradeSubtitle": "Unlock the full power of Flipping Pal",
    "enhancedFeatures": "Enhanced Features",
    "exclusiveFeatures": "Exclusive Premium Features",
    "alsoIncluded": "Also Included"
  },
  "footer": {
    "changelog": "Changelog"
  },
  "logoAlt": "Flipping Pal - your favorite WoW flipping site",
  "toggleNavAriaLabel": "Toggle navigation menu",
  "mainNavAriaLabel": "Main navigation",
  "toolNavAriaLabel": "Tool navigation",
  "simpleNavAriaLabel": "Simple navigation",
  "footerNavAriaLabel": "Footer navigation",
  "clipboard": {
    "copied": "Copied to clipboard!",
    "tsmCopied": "TSM string copied to clipboard!",
    "exportCopied": "Export code successfully copied to clipboard.",
    "auctionatorCopied": "Auctionator Shopping Lists copied to clipboard!",
    "titleCopied": "{{title}} copied to clipboard!",
    "copyFailed": "Failed to copy to clipboard"
  },
  "favorites": {
    "added": "Added to favorites",
    "removed": "Removed from favorites"
  },
  "enabled": "enabled",
  "disabled": "disabled",
  "dataRefreshed": "Data refreshed! Found {{count}} opportunities.",
  "notFound": {
    "title": "Page Not Found"
  },
  "paymentSuccess": {
    "title": "Payment Successful"
  },
  "pagination": {
    "summary": "Total items found: {{total}} | Results per page: {{perPage}}",
    "summaryWithPages": "Total items found: {{total}} | Results per page: {{perPage}} | Total Pages: {{pages}}",
    "label": "Pagination",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "lastPage": "Last page",
    "pageAriaLabel": "Page {{page}}"
  },
  "stats": {
    "totalInvestment": "Total Investment",
    "estimatedSellPrice": "Estimated Sell Price",
    "profitAfterAHCut": "Profit After AH Cut"
  },
  "filters": {
    "searchItems": "Search items...",
    "watchVideoGuide": "Watch video guide",
    "watchVideoIntro": "Watch video introduction",
    "crossRealmVideoGuide": "Cross realm flipping tool video guide",
    "dropshipVideoGuide": "Dropship flipping tool video guide",
    "housingVideoGuide": "Housing video guide",
    "downloadXLSX": "Download data as XLSX",
    "getAuctionatorLists": "Get Auctionator Lists",
    "quality": "Quality",
    "selectQuality": "Select Quality",
    "qualities": "qualities",
    "expansions": "Expansions",
    "selectExpansions": "Select Expansions",
    "expansionsMultiple": "expansions",
    "sellingRealms": "Selling Realms",
    "selectSellingRealms": "Select Selling Realms",
    "sellingRealmsMultiple": "selling realms",
    "buyingRealms": "Buying Realms",
    "selectBuyingRealms": "Select Buying Realms",
    "buyingRealmsMultiple": "buying realms",
    "categories": "Categories",
    "selectCategories": "Select Categories",
    "categoriesMultiple": "categories",
    "sellRate": "Sell Rate",
    "saleAvg": "Sale Avg",
    "haveCraftedItems": "Have crafted items",
    "profitOnSaleAvg": "Profit on Sale Avg",
    "saleAvgVsBuyPercent": "Sale Avg vs Buy %",
    "profitSellVsBuy": "Profit (Sell vs Buy)",
    "profitPercent": "Profit %",
    "maxGoldBuyout": "Max Gold Buyout",
    "ilvl": "ilvl",
    "activateProfitOnSaleAvg": "Activate profit on Sale Avg",
    "regionMarketValue": "Region Market Value",
    "regionHistorical": "Region Historical",
    "modeRecalculate": "Recalculate",
    "modeFilter": "Filter",
    "modeRecalculateHint": "Filter changes recalculate the results on the server",
    "modeFilterHint": "Filter changes only narrow down the already loaded results",
    "modeAria": "Filter change behavior",
    "modeLabel": "On filter change"
  },
  "table": {
    "noData": "No data found",
    "sellVsBuyTooltip": "5% auction house cut is taken into account for the profit calculation",
    "toggleAllFavorites": "Toggle all favorites",
    "clickToCopy": "Click to copy: {{name}}",
    "priceAfterAHCut": "Price after AH cut: {{price}}",
    "noCompetition": "No competition",
    "noCompetitionTooltip": "No known listing on the selling realm.",
    "population": "Population: {{population}}",
    "viewOnWowhead": "View {{name}} on Wowhead",
    "addToFavorites": "Add to favorites",
    "removeFromFavorites": "Remove from favorites",
    "sessionExpiredFavorite": "Session expired. Please log in again.",
    "failedToUpdateFavorite": "Failed to update favorite",
    "addSnipeAlert": "Add snipe alert",
    "editSnipeAlert": "Edit snipe alert",
    "headers": {
      "itemName": "Item Name",
      "category": "Category",
      "ilvl": "ilvl",
      "sellRate": "Sell Rate",
      "expansion": "Expansion",
      "quality": "Quality",
      "extraStats": "Extra Stats",
      "saleAvg": "Sale Avg",
      "regionMarketValue": "Region MV",
      "saleAvgVsBuy": "Sale Avg vs Buy",
      "sellVsBuy": "Sell vs Buy",
      "sellPrice": "Sell Price",
      "sellRealm": "Sell Realm",
      "buyPrice": "Buy Price",
      "buyRealm": "Buy Realm"
    },
    "columnsTitle": "Columns",
    "columnsReset": "Reset",
    "columnsDragToReorder": "Drag to reorder",
    "columnsToggleVisibility": "Click eye to toggle visibility",
    "columnSettings": "Column settings",
    "dragReorder": "Drag to reorder {{column}}",
    "hideColumn": "Hide {{column}}",
    "showColumn": "Show {{column}}",
    "rowActions": "Row actions",
    "actions": {
      "selectionSection": "Selection",
      "pinSection": "Pin to top",
      "selectPage": "Select page",
      "deselectPage": "Deselect page",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "sortFavorites": "Pin favorites",
      "sortSnipes": "Pin snipe alerts",
      "sortSelected": "Pin selected",
      "columnSettings": "Column settings..."
    },
    "sortHint": "Click to sort",
    "sortHintMulti": "Click to sort · Shift+Click for secondary sort",
    "selectRow": "Select {{name}}",
    "emptyFiltered": "No items match your current filters",
    "emptyResetFilters": "Reset filters",
    "emptyUpdating": "A region update is in progress — new data will arrive shortly."
  },
  "multipleSelect": {
    "noResults": "No results found",
    "selectAll": "Select All",
    "clearAll": "Clear All",
    "selectOption": "Select option",
    "selectMultipleOptions": "Select multiple options",
    "selected": "selected",
    "searchOptions": "Search options",
    "noItemsSelected": "No items selected",
    "search": "Search...",
    "items": "items"
  },
  "hierarchicalSelect": {
    "selectAll": "Select All",
    "clearAll": "Clear All",
    "expand": "Expand",
    "collapse": "Collapse",
    "selected": "selected",
    "noItemsSelected": "Select categories...",
    "items": "categories",
    "triggerAriaLabel": "Select {{items}}. {{count}} selected."
  },
  "hoverChart": {
    "high": "High:",
    "low": "Low:",
    "avg": "Avg:"
  },
  "tokenDisplay": {
    "label": "WoW Token",
    "signalBuy": "Buy signal — the price looks favorable right now",
    "signalWait": "Wait — the price is likely to keep falling",
    "signalHold": "Hold — no clear trend at the moment",
    "loading": "Loading...",
    "error": "Error",
    "priceHistory": "14-Day Price History",
    "high": "High: ",
    "low": "Low: ",
    "avg": "Avg: ",
    "momentum": "Momentum",
    "slowing": "Slowing ({{steps}})",
    "atCap": "At 1% cap",
    "steps": "{{count}} step",
    "stepsPlural": "{{count}} steps"
  },
  "nextUpdate": {
    "nextDataUpdate": "Next data update",
    "dataSourceStatus": "Data Source Status",
    "tsmData": "TSM Data:",
    "blizzardRealm": "Blizzard Realm:",
    "liveUpdates": "Live Updates:",
    "connected": "Connected",
    "reconnecting": "Reconnecting...",
    "retry": "Retry",
    "autoRefresh": "Auto Refresh:",
    "autoRefreshEnabled": "Page will auto-refresh when new data is available",
    "autoRefreshDisabled": "Click refresh icon when new data is ready",
    "loadingStatus": "Loading data status...",
    "viewStatus": "View data source status",
    "refreshData": "Refresh data",
    "reloading": "Reloading",
    "liveUpdatesConnected": "Live updates connected",
    "liveUpdatesReconnecting": "Reconnecting...",
    "tsmFresh": "TSM data is fresh (< 24h)",
    "tsmStale24": "TSM data is getting stale (24-25h)",
    "tsmStale25": "TSM data is stale (> 25h)",
    "toggleAutoRefresh": "Toggle auto-refresh"
  },
  "regionUpdateProgress": {
    "updating": "Updating Region Data",
    "realmsProgress": "{{updated}}/{{total}} realms ({{percent}}%)",
    "autoRefresh": "Data will refresh automatically when ready",
    "reloadPartial": "Partial data available — click to load now"
  },
  "filterFlyout": {
    "filtersButton": "Filters",
    "loadingPresets": "Loading...",
    "selectPreset": "Select preset...",
    "presetsSection": "Presets",
    "save": "Save",
    "update": "Update",
    "delete": "Delete",
    "export": "Export",
    "import": "Import",
    "importPreset": "Import preset…",
    "presetNamePlaceholder": "Preset name...",
    "shareCode": "Share this code:",
    "copy": "Copy",
    "done": "Done",
    "pasteCodePlaceholder": "Paste code here...",
    "applyFilters": "Apply Filters",
    "resetFilters": "Reset Filters",
    "refreshNow": "Refresh now",
    "reset": "Reset",
    "deletePresetTitle": "Delete preset",
    "deletePresetMessage": "Are you sure you want to delete this preset? This cannot be undone."
  },
  "filterSidebar": {
    "profitRange": "Profit Range",
    "crafted_include": "All items",
    "crafted_excluded": "Exclude crafted",
    "crafted_exclusive": "Only crafted",
    "showPositiveSaleAvgVsBuy": "Only positive Sale Avg vs Buy",
    "presetClickToDeselect": "Click to deselect preset",
    "collapseSidebar": "Collapse filters",
    "expandSidebar": "Expand filters"
  },
  "discord": {
    "title": "Discord Integration",
    "description": "Link your Discord account to receive personalized notifications and updates from our bot.",
    "accountLinked": "Discord Account Linked",
    "connectedAs": "Connected as:",
    "unlink": "Unlink",
    "dmVerifiedBadge": "DMs Verified: Your Discord can receive notifications from our bot.",
    "dmVerificationTitle": "DM Verification Required",
    "dmVerificationDesc": "To enable notifications, we need to confirm our bot can send you direct messages. Make sure you have DMs enabled for at least one server you share with our bot.",
    "sendVerificationCode": "Send Verification Code to My Discord",
    "sendingCode": "Sending Code...",
    "codeSentInstructions": "Check your Discord DMs for a 6-digit code from our bot. If you did not receive a DM, check in your settings under Content & Social -> Social permissions, that Direct messages is activated.",
    "enterCodePlaceholder": "Enter 6-digit code",
    "verify": "Verify",
    "resendCode": "Resend code",
    "notificationSettings": "Notification Settings",
    "verifyDmsFirst": "(verify DMs first)",
    "botFeaturesAvailable": "Bot Features Available: You can now receive private messages for region updates, item & pet snipes, ilvl boe snipes and wow token price.",
    "notConnected": "Not Connected: Link your Discord account to enable bot notifications and features.",
    "connectingToDiscord": "Connecting to Discord...",
    "linkAccount": "Link Discord Account",
    "regionUpdateLabel": "Region Update Notifications",
    "regionUpdateDesc": "Receive notifications when auction data is updated for your selected regions.",
    "sendTestDm": "Send test DM",
    "sendingTest": "Sending…",
    "sendTestWebhook": "Test",
    "testMessageHint": "Send a test message to confirm Discord delivery works without waiting for a real snipe.",
    "categoriesTitle": "Notification Categories",
    "categoriesDesc": "Route snipe alerts to different Discord channels. Each category has its own webhook URL and mention mode.",
    "categoriesPremiumHint": "Additional categories require a premium subscription.",
    "categoryNamePlaceholder": "Category name",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Mention:",
    "defaultLabel": "Default",
    "defaultCategoryTitle": "Default category",
    "noWebhookSet": "no webhook set",
    "setAsDefault": "Set as default",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "addCategory": "+ Add Category",
    "deleteCategoryTitle": "Delete category",
    "deleteCategoryMessage": "Are you sure you want to delete the category \"{{name}}\"? Alerts assigned to it will use your default category instead."
  },
  "csvExport": {
    "title": "CSV Export",
    "noItems": "No items available.",
    "copy": "Copy to Clipboard",
    "copied": "CSV copied to clipboard!",
    "copyFailed": "Failed to copy to clipboard",
    "download": "Download CSV"
  },
  "updateBanner": {
    "title": "Update available",
    "description": "A new version is ready.",
    "reload": "Reload",
    "dismiss": "Dismiss"
  },
  "premiumPreviewBanner": {
    "title": "You have full Premium access",
    "dayLeftOne": "1 day left",
    "daysLeft": "{{count}} days left",
    "dismiss": "Dismiss"
  },
  "tour": {
    "start": "Start tour for this page"
  },
  "dashboard": {
    "loadError": "Couldn't load dashboard data. Check your connection and try again.",
    "greeting": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "evening": "Good evening"
    },
    "subtitle": "Here's what's happening across the auction house today.",
    "kpi": {
      "opportunities": "Opportunities"
    },
    "topOpportunities": {
      "title": "Top Opportunities",
      "viewAll": "View all",
      "itemsFound": "items found across",
      "realms": "realms",
      "openTool": "Open Flipping Tool",
      "ilvl": "ilvl",
      "sellRate": "sell rate",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Failed to save settings. Reverted to the last saved value.",
      "saved": "Saved",
      "sellRateTooltip": "Sale rate is on a 0–1 scale: the share of listed auctions that actually sell each day. 0.1 ≈ 10% of listings sell."
    },
    "recentSnipes": {
      "title": "Recent Snipes",
      "monitoringRealms": "Monitoring {{count}} realms",
      "vsTarget": "vs target",
      "itemsMonitored": "items being monitored",
      "configureAlerts": "Configure Alerts",
      "noSnipes": "No snipes detected this cycle",
      "saved": "saved"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "View Realm Stats"
    },
    "quickAccess": {
      "title": "Quick Access"
    },
    "onboarding": {
      "title": "Getting Started",
      "progress": "{{done}}/{{total}} done",
      "hide": "Hide checklist",
      "steps": {
        "realms": "Configure your realms",
        "preset": "Create a starter filter preset",
        "flipping": "Run your first flipping scan",
        "discordLink": "Link your Discord account",
        "snipe": "Set up snipe alerts",
        "discordJoin": "Join the Discord server"
      },
      "createPreset": "Create preset",
      "creatingPreset": "Creating…",
      "starterPresetName": "Starter",
      "configureRealmsFirst": "Configure your realms first to create a preset",
      "presetLimitReached": "You've reached your saved preset limit",
      "createPresetFailed": "Failed to create the preset. Please try again."
    },
    "activity": {
      "title": "Activity",
      "timeAgoLess1m": "<1m ago",
      "timeAgoMinutes": "{{count}}m ago",
      "timeAgoHours": "{{count}}h ago",
      "dataRefreshed": "Data refreshed — {{n}} opportunities found",
      "realmDataUpdated": "{{region}} realm data updated",
      "waitingForData": "Waiting for first data refresh…",
      "snipeAlertsActive": "Snipe alerts are active and monitoring your configured realms",
      "tokenTracked": "WoW Token price is being tracked every 20 minutes"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Back to top",
  "slider": {
    "min": "Min",
    "max": "Max",
    "minAriaLabel": "Minimum value",
    "maxAriaLabel": "Maximum value",
    "numericInput": "{{label}} numeric input"
  },
  "inputBox": {
    "clear": "Clear input",
    "required": "required"
  },
  "auctionator": {
    "title": "Auctionator Shopping Lists",
    "account": "Account:",
    "allAccounts": "All Accounts",
    "noItems": "No items available for the selected account."
  },
  "popup": {
    "getTitle": "Get {{title}}",
    "content": "Content",
    "noContent": "No content available",
    "copyTitle": "Copy {{title}}",
    "copyContent": "Copy content",
    "titleContent": "{{title}} content",
    "videoContent": "Video content",
    "videoNotSupported": "Your browser does not support the video tag."
  },
  "snipePopup": {
    "ariaLabel": "Snipe alert for {{name}}",
    "titleItem": "Item Snipe Alert",
    "titlePet": "Pet Snipe Alert",
    "maxBuyoutPrice": "Max buyout price",
    "pricePlaceholder": "e.g. 500g or 500g 50s",
    "saving": "Saving...",
    "updateAlert": "Update Alert",
    "setAlert": "Set Alert"
  },
  "refreshingData": "Refreshing data...",
  "toolAccess": {
    "subscriptionRequired": "You need a subscription active to use the tool!",
    "premiumRequired": "You need a premium subscription active to use the tool!"
  }
}
